export interface StaticInstrumentConfig {
    type: 'Crypto' | 'FX' | 'Index' | 'Commodity' | 'Future';
    price_decimals: number;
    pip_size: number;
    ccy2_enabled: 0 | 1;
    ccy1?: string;
    ccy2?: string;
    netdania: string;
    provider: 'netdania_rtc' | 'cryptoxchange' | '';
    assetName?: string;
    gcexSymbol: string;
    tsSymbol?: string;
    product_type?: 'Crypto' | 'FX' | 'Index' | 'Commodity' | 'Future';
}

const instrumentConfig = {
    'XBR/USD': {
        product_type: 'FX'
    },
    'XTI/USD': {
        product_type: 'FX'
    },
    'XNG/USD': {
        product_type: 'FX'
    },
    'XAL/USD': {
        product_type: 'FX'
    },
    'XNI/USD': {
        product_type: 'FX'
    },
    'XCU/USD': {
        product_type: 'FX'
    },
    'XZN/USD': {
        product_type: 'FX'
    },
    'XPB/USD': {
        product_type: 'FX'
    },
    'AXS/USD': {
        product_type: 'FX'
    },
    'CHZ/USD': {
        product_type: 'FX'
    },
    'ARB/USD': {
        product_type: 'FX'
    },
    'PNU/USD': {
        product_type: 'FX'
    },
    'FLR/USD': {
        product_type: 'FX'
    },
    'MEW/USD': {
        product_type: 'FX'
    },
    'OPX/USD': {
        product_type: 'FX'
    },
    'XAG/EUR': {
        product_type: 'FX'
    },
    'SKY/USD': {
        product_type: 'FX'
    }
};

export default instrumentConfig;
